export const formatCpfMasked = (cpf: string) => {
	if (!cpf) {
		return cpf;
	}

	const clean = cpf.replace(/\D/g, "");

	if (clean.length !== 11) {
		return cpf;
	}

	const firstPart = "***.***.";
	const secondPart = `**${clean[8]}`;
	const thirdPart = `-${clean[9]}${clean[10]}`;

	return firstPart + secondPart + thirdPart;
};

export const maskCPF = (value?: string) => {
	if (!value) {
		return "";
	}

	const onlyNumbers = value.replace(/\D/g, "");

	return onlyNumbers
		.replace(/^(\d{3})(\d)/, "$1.$2")
		.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
		.replace(/\.(\d{3})(\d)/, ".$1-$2")
		.slice(0, 14);
};
